<template>
  <!-- 电话号码登录 -->
  <div class="box-input">
    <!-- 账号 -->
    <div class="account-number">
      <!-- <el-button plain>+86</el-button> -->

      <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
      <el-input
        class="account-input"
        v-model="myphonenum"
        placeholder="请输入手机号/邮箱"
        autocomplete="off"
        :class="{ 'focus-border': mydata.focusPhone }"
        @focus="mydata.focusPhone = true"
        @blur="mydata.focusPhone = false"
      />
      <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
      <!-- <el-input
        class="account-input"
        v-model="myphonenum"
        placeholder="请输入邮箱"
        autocomplete="off"
        :class="{ 'focus-border': mydata.focusPhone }"
        @focus="mydata.focusPhone = true"
        @blur="mydata.focusPhone = false"
      /> -->
    </div>

    <!-- 获取验证码按钮 -->
    <div class="box-password">
      <el-input
        class="password-input"
        v-model="myphonecode"
        placeholder="请输入验证码"
        :class="{ 'focus-border': mydata.focusCode }"
        @focus="mydata.focusCode = true"
        @blur="mydata.focusCode = false"
      />
      <el-button
        class="password-button"
        @click="submit"
        :disabled="mydata.btnDisabled"
        >{{ mydata.btnText }}</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { User, Lock } from "@element-plus/icons-vue";

// 引入手机号验证码发送接口
import { setLoginCode } from "@/api/login/retrievePasswordLogin/index.js";

//验证是否为手机号
import { isPhoneNumber, isEmail } from "@/utils/validate.js";

const router = useRouter();

// 手机号（vue3新语法，v-model:modelValue 的语法糖，功能就是 这个变量（"myphonenum""myphonecode"） 在父子组件里面 双向绑定）
const myphonenum = defineModel("myphonenum");

// 验证码
const myphonecode = defineModel("myphonecode");

var mydata = reactive({
  btnText: "获取验证码",
  btnDisabled: false,

  form: {
    phone: "",
    code: "",
  },
  checked1: false,

  ////
  focusPhone: false,
  focusCode: false,
  type: "", // (手机：phone，邮箱：email)
});

//获取验证码,按钮点击事件
function submit() {
  // 如果不是手机号，也不是邮箱，那么提醒弹窗并终止代码
  if (
    isPhoneNumber(myphonenum.value) === false &&
    isEmail(myphonenum.value) === false
  ) {
    ElMessage({
      message: "手机号/邮箱格式错误",
      type: "warning",
    });
    return;
  }
  //判断是手机号还是邮箱
  mydata.type = isPhoneNumber(myphonenum.value) ? "phone" : "email";
  //禁用“获取验证码按钮”
  mydata.btnDisabled = true;
  //修改“获取验证码按钮”的内容（开始倒计时）
  let num = 60;
  let intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      //清除定时器并不禁用“获取验证码按钮”
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用setLoginCode方法，发送获取验证码请求
  setLoginCode({
    account: myphonenum.value,  //手机号/邮箱号
    type: mydata.type,          //是手机类型还是邮箱类型
  })
    .then((res) => {
      // 提示弹窗（获取验证码成功）
      ElMessage({
        message: res.msg,
        type: "success",
      });
    })
    .catch((err) => {
      //获取验证码失败后再修改“获取验证码按钮”的内容为"获取验证码"，并清楚定时器，并不禁用“获取验证码按钮”（目的：假如用户第50秒的时候就获取验证码失败了，就不用继续等剩下的50秒了）
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    });
}
</script>

<style scoped lang="scss">
.box-input {
  .account-number {
    margin-bottom: 15px;
  }
  .account-number,
  .box-password {
    display: flex;
    height: 48px;
    //账号按钮
    :deep(.el-button.is-plain) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 65px;
      height: 48px;
      border-right: 0px;
      border-radius: 4px 0px 0px 4px;
      margin-bottom: 0px;
    }

    //密码按钮
    :deep(.el-button.password-button) {
      // border:1px solid red;
      border: 1px solid #dbdbdb;
      width: 100px;
      height: 48px;
      font-size: 15px;
      border-left: 0px;
      border-radius: 0px 4px 4px 0px;
      margin-bottom: 0px;
    }

    //账号输入框
    :deep(.el-input.account-input > .el-input__wrapper) {
      border-radius: 4px;
      border: 1px solid #dbdbdb;
    }
    //密码输入框
    :deep(.el-input.password-input > .el-input__wrapper) {
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #dbdbdb;
    }
  }

  //整个输入框
  :deep(.el-input) {
    width: 100% !important;
    height: 48px;
    // margin-bottom: 10px;
  }
  //整个输入框
  :deep(.el-input > .el-input__wrapper) {
    box-shadow: none;
    // border: 1px solid #dbdbdb;
    // border: 1px solid red;
    > .el-input__inner {
      font-size: 15px;
      // color:red;
    }
  }

  :deep(.el-input.el-input--suffix) {
    // border:1px solid blue;
    margin-bottom: 0px;
  }
  //输入框中提示文字
  :deep(.el-input__wrapper > .el-input__inner::placeholder) {
    color: #666666;
    font-size: 14px;
    font-weight: 300;
    // color:blue;
  }
}

//鼠标在输入框中时，边框变蓝色
.focus-border {
  :deep(.el-input__wrapper) {
    border: 1px solid #409eff !important;
    .el-icon {
      color: #409eff;
    }
  }
}
</style>
